// components/FormActions.jsx
import React from "react";
import { Box, Button, CircularProgress } from "@mui/material";
import { Cancel as CancelIcon, Save as SaveIcon } from "@mui/icons-material";

const FormActions = ({ isSubmitting, onCancel, onSubmit }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        gap: 2,
        mt: 3,
        pt: 2,
        borderTop: "1px solid #E2E8F0",
      }}
    >
      <Button
        variant="outlined"
        onClick={onCancel}
        disabled={isSubmitting}
        startIcon={<CancelIcon sx={{ fontSize: 18 }} />}
        size="small"
        sx={{
          textTransform: "none",
          fontWeight: 500,
          borderRadius: "6px",
          borderColor: "#D0D5DD",
          color: "#344054",
          px: 3,
          py: 0.75,
          "&:hover": {
            bgcolor: "#F9FAFB",
            borderColor: "#98A2B3",
          },
        }}
      >
        Cancel
      </Button>
      <Button
        type="submit"
        variant="contained"
        disabled={isSubmitting}
        startIcon={isSubmitting ? <CircularProgress size={18} color="inherit" /> : <SaveIcon sx={{ fontSize: 18 }} />}
        size="small"
        sx={{
          textTransform: "none",
          fontWeight: 600,
          borderRadius: "6px",
          bgcolor: "#2469F0",
          px: 3,
          py: 0.75,
          "&:hover": {
            bgcolor: "#1A5BD4",
            boxShadow: "0px 2px 8px rgba(36, 105, 240, 0.3)",
          },
        }}
        onClick={onSubmit}
      >
        {isSubmitting ? "Updating..." : "Update Visit"}
      </Button>
    </Box>
  );
};

export default FormActions;